export default __webpack_public_path__ + "static/package-icon-d2e55edab214fed417633accb2534375.png";